<form style="margin-bottom: 20px !important;" [formGroup]="formContratante">
  <div class="row p-0 m-0 mt-5">
    <div class="col-xs-12 col-md-6 col-lg-6 form-group-tipo-documento">
      <mat-label>
        Tipo de documento *
        <mat-icon 
          class="icono-ayuda" 
          matTooltip="Seleccione el tipo de documento de identidad del contratante"
          matTooltipPosition="right">
          help_outline
        </mat-icon>
      </mat-label>
      <mat-form-field class="" color="primary" appearance="outline"
        [class.tipo-documento-inclusion-bloqueado]="esInclusionSoloLectura || documentoBloqueadoPorCotizacion">
        <mat-select formControlName="tipoDocumento" [disabled]="documentoBloqueadoPorCotizacion">
          <mat-option>Seleccionar</mat-option>
          <mat-option *ngFor="let item of listaTipoDocumento" [value]="item.codigo">
            {{item.descripcion}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <!-- Mensaje de error fuera del mat-form-field para evitar solapamiento y controlar el flujo responsive -->
      <div class="error-message-block" *ngIf="campoInvalido('tipoDocumento')" role="alert">
        {{ obtenerMensajeError('tipoDocumento') }}
      </div>
    </div>
    <div class="col-xs-12 col-md-6 col-lg-6 form-group-tipo-documento">
      <mat-label>
        No. Documento *
        <mat-icon 
          class="icono-ayuda" 
          matTooltip="Ingrese el número de documento. Máximo 30 caracteres alfanuméricos. Use el ícono de lupa para buscar"
          matTooltipPosition="right">
          help_outline
        </mat-icon>
      </mat-label>
      <mat-form-field appearance="outline"
        [class.campo-documento-bloqueado]="esInclusionSoloLectura || documentoBloqueadoPorCotizacion">
        <input 
          (keyup.enter)="!esInclusionSoloLectura && !esEditMode && !documentoBloqueadoPorCotizacion && buscarContratante()" 
          (input)="convertirAMayusculas('numeroDocumento')"
          formControlName="numeroDocumento" 
          matInput 
          #message
          [readonly]="esInclusionSoloLectura || documentoBloqueadoPorCotizacion"
          maxlength="30" 
          placeholder="#">

        <mat-icon 
          (click)="!esInclusionSoloLectura && !esEditMode && !documentoBloqueadoPorCotizacion && buscarContratante()" 
          matSuffix 
          [style.cursor]="(puedeConsultar() && !esInclusionSoloLectura && !esEditMode && !documentoBloqueadoPorCotizacion) ? 'pointer' : 'not-allowed'">
          search
        </mat-icon>

        <mat-hint align="end">
          <label>{{ message.value.length }}</label> / 30
        </mat-hint>
      </mat-form-field>

      <div class="error-message-block" *ngIf="campoInvalido('numeroDocumento')" role="alert">
        {{ obtenerMensajeError('numeroDocumento') }}
      </div>
    </div>
  </div>
  <div class="row p-0 m-0">
    <div class="col-xs-12 col-md-3">
      <mat-label>
        Nombre *
        <mat-icon 
          class="icono-ayuda" 
          matTooltip="Letras y espacios. No se aceptan caracteres especiales."
          matTooltipPosition="right">
          help_outline
        </mat-icon>
      </mat-label>
      <mat-form-field class="example-full-width" appearance="outline">
        <input formControlName="primerNombre" matInput minlength="3" maxlength="40"
          [readonly]="esInclusionSoloLectura"
          (input)="convertirAMayusculas('primerNombre')"
          (blur)="recortarBordesNombreAlBlur('primerNombre')">
      </mat-form-field>
      <!-- Mensaje de error fuera del mat-form-field para evitar solapamiento y controlar el flujo responsive -->
      <div class="error-message-block" *ngIf="campoInvalido('primerNombre')" role="alert">
        {{ obtenerMensajeError('primerNombre') }}
      </div>
    </div>
    <div class="col-xs-12 col-md-3">
      <mat-label>
        Segundo nombre
        <mat-icon 
          class="icono-ayuda" 
          matTooltip="Opcional. Letras y espacios. No se aceptan caracteres especiales."
          matTooltipPosition="right">
          help_outline
        </mat-icon>
      </mat-label>
      <mat-form-field class="example-full-width" appearance="outline">
        <input formControlName="segundoNombre" matInput minlength="3" maxlength="40"
          [readonly]="esInclusionSoloLectura"
          (input)="convertirAMayusculas('segundoNombre')"
          (blur)="recortarBordesNombreAlBlur('segundoNombre')">
      </mat-form-field>
      <!-- Mensaje de error fuera del mat-form-field para evitar solapamiento y controlar el flujo responsive -->
      <div class="error-message-block" *ngIf="campoInvalido('segundoNombre')" role="alert">
        {{ obtenerMensajeError('segundoNombre') }}
      </div>
    </div>
    <div class="col-xs-12 col-md-3">
      <mat-label>
        Primer apellido *
        <mat-icon 
          class="icono-ayuda" 
          matTooltip="Letras y espacios. No se aceptan caracteres especiales."
          matTooltipPosition="right">
          help_outline
        </mat-icon>
      </mat-label>
      <mat-form-field class="example-full-width" appearance="outline">
        <input formControlName="primerApellido" matInput minlength="3" maxlength="40"
          [readonly]="esInclusionSoloLectura"
          (input)="convertirAMayusculas('primerApellido')"
          (blur)="recortarBordesNombreAlBlur('primerApellido')">
      </mat-form-field>
      <!-- Mensaje de error fuera del mat-form-field para evitar solapamiento y controlar el flujo responsive -->
      <div class="error-message-block" *ngIf="campoInvalido('primerApellido')" role="alert">
        {{ obtenerMensajeError('primerApellido') }}
      </div>
    </div>
    <div class="col-xs-12 col-md-3">
      <mat-label>
        Segundo apellido
        <mat-icon 
          class="icono-ayuda" 
          matTooltip="Opcional. Letras y espacios. No se aceptan caracteres especiales."
          matTooltipPosition="right">
          help_outline
        </mat-icon>
      </mat-label>
      <mat-form-field class="example-full-width" appearance="outline">
        <input formControlName="segundoApellido" matInput minlength="3" maxlength="40"
          [readonly]="esInclusionSoloLectura"
          (input)="convertirAMayusculas('segundoApellido')"
          (blur)="recortarBordesNombreAlBlur('segundoApellido')">
      </mat-form-field>
      <!-- Mensaje de error fuera del mat-form-field para evitar solapamiento y controlar el flujo responsive -->
      <div class="error-message-block" *ngIf="campoInvalido('segundoApellido')" role="alert">
        {{ obtenerMensajeError('segundoApellido') }}
      </div>
    </div>
  </div>
  <div class="row p-0 m-0">
    <div class="col-xs-12 col-md-3">
      <mat-label>
        Género *
        <mat-icon 
          class="icono-ayuda" 
          matTooltip="Seleccione el género del contratante: F (Femenino) o M (Masculino)"
          matTooltipPosition="right">
          help_outline
        </mat-icon>
      </mat-label>
      <div style="margin-top:20px" class="form-group">
        <mat-radio-group formControlName="genero" color="primary" [disabled]="esInclusionSoloLectura">
          <mat-radio-button value="F" [disabled]="esInclusionSoloLectura">F</mat-radio-button>
          <mat-radio-button class="margin-left-5" value="M" [disabled]="esInclusionSoloLectura">M</mat-radio-button>
        </mat-radio-group>
      </div>
      <!-- Mensaje de error fuera del mat-form-field para evitar solapamiento y controlar el flujo responsive -->
      <div class="error-message-block" *ngIf="campoInvalido('genero')" role="alert">
        {{ obtenerMensajeError('genero') }}
      </div>
    </div>
    <div class="col-xs-12 col-md-5">
      <mat-label>
        Fecha de nacimiento *
        <mat-icon 
          class="icono-ayuda" 
          matTooltip="Fecha de nacimiento del contratante. Debe ser mayor de 18 años"
          matTooltipPosition="right">
          help_outline
        </mat-icon>
      </mat-label>
      <mat-form-field appearance="outline">
        <input id="txtFechaNacimiento" matInput [min]="fechaMinima" [max]="fechaMaxima"
         autocomplete="off" [readonly]="esInclusionSoloLectura"
         (dateChange)="calcularEdad($event)" [matDatepicker]="picker"
         formControlName="fechaNacimiento">
            <mat-datepicker-toggle matSuffix [for]="picker" [disabled]="esInclusionSoloLectura"></mat-datepicker-toggle>
            <mat-datepicker touchUi #picker></mat-datepicker>
        </mat-form-field>
      <!-- Mensaje de error fuera del mat-form-field para evitar solapamiento y controlar el flujo responsive -->
      <div class="error-message-block" *ngIf="campoInvalido('fechaNacimiento')" role="alert">
        {{ obtenerMensajeError('fechaNacimiento') }}
      </div>
        </div>
    
    <div class="col-xs-12 col-md-4">
      <mat-label style="margin-right: 5%;">Edad</mat-label>
      <div>
          <div class="numberCircle">{{edad}}</div>
      </div>
    </div>
  </div>

  <!-- Sección eliminada: "Contratante es usuario" (irá en modal) -->
  
  <div class="row p-0 m-0">
    <div class="col-md-6">
      <mat-label>
        Correo electrónico *
        <mat-icon 
          class="icono-ayuda" 
          matTooltip="Ingrese el correo electrónico principal del contratante"
          matTooltipPosition="right">
          help_outline
        </mat-icon>
      </mat-label>
      <mat-form-field class="example-full-width" appearance="outline">
        <input id="contratanteEmailPrincipal" type="email" minlength="10" matInput
          formControlName="emailPrincipal" autocomplete="off" [readonly]="esInclusionSoloLectura"
          placeholder="Ej. correo@Ejemplo.com">
        <mat-hint></mat-hint>
      </mat-form-field>
      <!-- Mensaje de error fuera del mat-form-field para evitar solapamiento y controlar el flujo responsive -->
      <div class="error-message-block" *ngIf="campoInvalido('emailPrincipal')" role="alert">
        {{ obtenerMensajeError('emailPrincipal') }}
      </div>
    </div>
    <div class="col-md-6">
      <mat-label>
        Correo electrónico 2
        <mat-icon 
          class="icono-ayuda" 
          matTooltip="Correo electrónico secundario (opcional)"
          matTooltipPosition="right">
          help_outline
        </mat-icon>
      </mat-label>
      <mat-form-field class="example-full-width" appearance="outline">
        <input id="contratanteEmailSecundario" type="email" minlength="10" matInput
          formControlName="emailSecundario" autocomplete="off" [readonly]="esInclusionSoloLectura"
          placeholder="Ej. correo2@Ejemplo.com">
        <mat-hint></mat-hint>
      </mat-form-field>
      <!-- Mensaje de error fuera del mat-form-field para evitar solapamiento y controlar el flujo responsive -->
      <div class="error-message-block" *ngIf="campoInvalido('emailSecundario')" role="alert">
        {{ obtenerMensajeError('emailSecundario') }}
      </div>
    </div>
  </div>
  <div class="row p-0 m-0">
    <div class="col-md-6">
      <mat-label>
        Teléfono celular *
        <mat-icon 
          class="icono-ayuda" 
          matTooltip="Ingrese el teléfono celular del contratante. Entre 7 y 15 dígitos"
          matTooltipPosition="right">
          help_outline
        </mat-icon>
      </mat-label>
      <mat-form-field class="example-full-width" appearance="outline">
        <input id="contratanteTelefono" matInput minlength="7" maxlength="15" #messageTel
          formControlName="telefono" autocomplete="off" [readonly]="esInclusionSoloLectura"
          (keypress)="validarSoloNumeros($event)">
        <mat-hint align="end">{{messageTel.value.length}} / 15</mat-hint>
      </mat-form-field>
      <!-- Mensaje de error fuera del mat-form-field para evitar solapamiento y controlar el flujo responsive -->
      <div class="error-message-block" *ngIf="campoInvalido('telefono')" role="alert">
        {{ obtenerMensajeError('telefono') }}
      </div>
    </div>
    <div class="col-md-6">
      <mat-label>
        Teléfono fijo
        <mat-icon 
          class="icono-ayuda" 
          matTooltip="Teléfono fijo del contratante (opcional). Entre 7 y 10 dígitos"
          matTooltipPosition="right">
          help_outline
        </mat-icon>
      </mat-label>
      <mat-form-field class="example-full-width" appearance="outline">
        <input #telefonoFijo formControlName="telefonoFijo" minlength="7" maxlength="10"
          [readonly]="esInclusionSoloLectura"
          (keypress)="validarSoloNumeros($event)" matInput>
        <mat-hint align="end">{{telefonoFijo.value.length}} / 10</mat-hint>
      </mat-form-field>
      <!-- Mensaje de error fuera del mat-form-field para evitar solapamiento y controlar el flujo responsive -->
      <div class="error-message-block" *ngIf="campoInvalido('telefonoFijo')" role="alert">
        {{ obtenerMensajeError('telefonoFijo') }}
      </div>
    </div>
  </div>

  <!-- Botones de Acción -->
  <div class="row p-0 m-0 mt-4 mb-4">
    <div class="col-12 d-flex justify-content-center gap-3 acciones-formulario">
      <button 
        type="button"
        class="btn-action btn-limpiar"
        [disabled]="esInclusionSoloLectura || !formularioTieneDatos()"
        (click)="limpiarFormulario()">
        LIMPIAR
      </button>

      <button 
        type="button"
        class="btn-action btn-consultar"
        [disabled]="!puedeConsultarCompleto() || soloLectura"
        (click)="consultarValidaciones()">
        CONSULTAR
      </button>
    </div>
  </div>
</form>

